import { formatNumber } from './formatNumber';

type FormatMoneyOptions = {
  fixedDecimal?: boolean;
  currency?: string;
};

export function formatMoney(
  value?: number | bigint | null,
  options?: FormatMoneyOptions,
): string {
  const currency = options?.currency ?? 'kr';

  return `${value ? formatNumber(value, options) : '-'} ${currency}`.replace(
    ' ',
    '\u00a0',
  );
}
